import { render, staticRenderFns } from "./QuestionPhone.vue?vue&type=template&id=4c60dfbc&"
import script from "./QuestionPhone.vue?vue&type=script&lang=js&"
export * from "./QuestionPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports